
const digest = 'ced73543c841aaaffff6f52034c184f22e2a2aa312c40e0c6ff2a79b77b18db1';
const classes = {"wrapper":"_wrapper_s6hl8_1","item":"_item_s6hl8_9","content":"_content_s6hl8_15","title":"_title_s6hl8_22","subItems":"_subItems_s6hl8_27","subItem":"_subItem_s6hl8_27","label":"_label_s6hl8_40","value":"_value_s6hl8_43","controls":"_controls_s6hl8_46"};
const css = `._wrapper_s6hl8_1 {
  border-top: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}
._wrapper_s6hl8_1 ._item_s6hl8_9 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  border: 1px solid #eaedf3;
}
._wrapper_s6hl8_1 ._item_s6hl8_9 ._content_s6hl8_15 {
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 20px;
  flex: 1;
}
._wrapper_s6hl8_1 ._item_s6hl8_9 ._content_s6hl8_15 ._title_s6hl8_22 {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}
._wrapper_s6hl8_1 ._item_s6hl8_9 ._content_s6hl8_15 ._subItems_s6hl8_27 {
  display: flex;
  flex-direction: row;
  row-gap: 10px;
  column-gap: 20px;
  flex-wrap: wrap;
}
._wrapper_s6hl8_1 ._item_s6hl8_9 ._content_s6hl8_15 ._subItems_s6hl8_27 ._subItem_s6hl8_27 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_s6hl8_1 ._item_s6hl8_9 ._content_s6hl8_15 ._subItems_s6hl8_27 ._subItem_s6hl8_27 ._label_s6hl8_40 {
  color: #808080;
}
._wrapper_s6hl8_1 ._item_s6hl8_9 ._content_s6hl8_15 ._subItems_s6hl8_27 ._subItem_s6hl8_27 ._value_s6hl8_43 {
  color: #000000;
}
._wrapper_s6hl8_1 ._item_s6hl8_9 ._controls_s6hl8_46 {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-left: 1px solid #eaedf3;
  justify-content: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  